import * as libRegions from '@luxuryescapes/lib-regions';

export const getCurrencyCodeByRegionCode = (regionCode: string): string | null => {
  const region = libRegions.getRegions().find((region) => region.code === regionCode);
  return region ? region.currencyCode : null;
};
